import { createQuery } from '@/queries'
import { getPeople } from '@/features/profile/api/people'
import type { Person } from '@/types/people'

export const usePeopleQuery = () => {
  return createQuery<Person[]>({
    key: ['people'],
    fetcher: getPeople,
  })
}
